<template>
  <main>
    <div class="clearfix">
      <p class="h5 mt2 gibson darkblue line-height-golden regular">
        Her kan du ændre på rækkefølgen af siderne i menuen på din hjemmeside
      </p>
      <template>
        <div class="clearfix" v-if="!showXXL">
          <div class="panel xs-col-12 sm-col-12 md-col-6 lg-col-4">
            <div class="panel-body">
              <div class="dd" id="nestable_list_1">
                <ol class="dd-list">
                  <li class="dd-item" v-for="item in filteredSorts" :key="item.id">
                    <div v-if="item.level === 0" :data-id="item.id"  class="dd-handle col-12 p2 not-rounded border-none flex justify-between items-center primarycolor" style="height:auto;">
                      <span class="h6 gibson regular primarycolor">{{item.label  }}</span>
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-menu"><path d='M1 0h5a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm7 8h5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2zM1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z' /></svg>
                      </span>
                    </div>
                    <ol class="dd-list"  v-if="CheckSort(item.id)">
                      <li class="dd-item"  v-for="subitem in filteredSorts" :key="subitem.id">
                        <div v-if="subitem.level === item.id" :data-id="subitem.id" class="dd-handle col-12 p2 not-rounded border-none flex justify-between items-center primarycolor" style="height:auto;">
                          <span class="h5 gibson regular primarycolor">
                            {{ subitem.label }}
                          </span>
                          <span>
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-menu"><path d='M1 0h5a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm7 8h5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2zM1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z' /></svg>
                          </span>
                        </div>
                      </li>
                    </ol>
                  </li>
                </ol>
              </div>
            </div>
            <div class="py2"></div>
            <div class="clearfix">
              <button class="col-12 not-rounded p2 border-none action-button gibson h4 regular flex justify-center items-center" @click="updateOutput()">
                <span>
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
                </span>
                <span class="mx2">Opdater</span>
              </button>
            </div>
          </div>
        </div>
        <div class="clearfix" v-if="showXXL">
          <div class="panel col-5">
            <div class="panel-body">
              <div class="dd" id="nestable_list_1">
                <ol class="dd-list">
                  <li class="dd-item" v-for="item in filteredSorts" :key="item.id">
                    <div v-if="item.level === 0" :data-id="item.id"  class="dd-handle col-12 px2 py1 not-rounded border-none flex justify-between items-center darkblue" style="height:auto;">
                      <span class="h6 gibson regular line-height-1 m0 p0">{{item.label}}</span>
                      <span>
                       <i class="el-icon-rank"></i>
                      </span>
                    </div>
                    <ol class="dd-list" v-if="CheckSort(item.id)">
                      <li class="dd-item" v-for="subitem in filteredSorts" :key="subitem.id">
                        <div v-if="subitem.level === item.id" :data-id="subitem.id" class="dd-handle col-12 p2 not-rounded border-none flex justify-between items-center primarycolor" style="height:auto;">
                          <span class="h6 gibson regular line-height-1 m0 p0">
                            {{ subitem.label }}
                          </span>
                          <span>
                            <i class="el-icon-rank"></i>
                          </span>
                        </div>
                      </li>
                    </ol>
                  </li>
                </ol>
              </div>
            </div>
            <div class="py2"></div>
            <div class="clearfix">
              <button class="not-rounded p2 border-none action-button gibson h5 regular flex justify-center items-center" @click="updateOutput()">
                <span>
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
                </span>
                <span class="mx2">Opdater</span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'websitesort',
  components: {
    loading,
    Simplert
  },
  props: ['filteredPosts', 'filteredSorts', 'titles'],
  data () {
    return {
      showModal: false,
      showCollapse: false,
      show: false,
      label: 'Loading...',
      picked: '',
      overlay: true,
      isLoadingReview: false,
      Cpage: '',
      Page: {
        id: '',
        title: '',
        note: '',
        active: true,
        image: '',
        page: ''
      },
      header: '',
      kind: '',
      post: '',
      sortKey: 'tittle'
    }
  },
  created () {
    if (screen.width >= 1300) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    this.Reload()
  },
  methods: {
    Reload () {
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 2
        })
      }, 3500)
    },
    CheckSort (id) {
      for (var item in this.filteredSorts) {
        if (this.filteredSorts[item].level === id) return true
      }
      return false
    },
    updateOutput (e) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'website_sort', salesPerson: this.salesPerson, levid: this.haaId, sort: JSON.stringify($('#nestable_list_1').nestable('serialize'))}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.showCollapse = false
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>
<style>
.tab-content {
    border:0;
}
.col-form-label {
    font-weight: 600;
}
.card-header {
    background: none;
}
</style>



// WEBPACK FOOTER //
// websitesort.vue?418616de